import requestsApi from '@/api/requests'

export const resetState = ({ commit }) => {
  commit('resetState')
}

export const load = ({ commit }, groupId) => {
  return requestsApi.getAllInGroup(groupId).then(data => {
    commit('setRequests', data)

    return data
  })
}

export const addRequests = ({ commit }, request_acess) => {
  commit('addRequests', request_acess)
}

export const denyRequest = ({ commit }, request_acess) => {
  return requestsApi.ignore(request_acess.id, request_acess.user_id)
    .then(() => {
      commit('removeRequest', request_acess)
    })
}

export const denyAll = ({ commit }, group_id) => {
  return requestsApi.clearAll(group_id)
    .then(() => {
      commit('resetState')
    })
}

export const grantRequest = ({ commit }, request_acess) => {
  return requestsApi.grant(request_acess.id, request_acess.user_id)
    .then(() => {
      commit('removeRequest', request_acess)
    })
}

export const removeRequest = ({ commit }, request_acess) => {
  commit('removeRequest', request_acess)
}